<template>
    <ion-toolbar>
        <ion-buttons slot="start"
            v-if="$store.state.pages.auth.back.length || currentStep > 0 || routeName == 'profile_travel'">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <!-- <ion-buttons slot="end" v-if="routeName != 'profile_travel'">
            <ion-button @click="skip">
                <span>Skip</span>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>Travel Requirements</h1>
                    <span></span>
                </div>
                <div class="brand-icon">
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
                </div>
            </div>
            <el-form class="full_page" :label-position="'top'" @submit.prevent="setStepValue(1)">
                <div class="form_text" v-if="currentStep == 0">
                    <div class="text">
                        Are you willing to work outside metro areas?
                    </div>
                </div>
                <div class="form_text" v-if="currentStep == 1">
                    <div class="text">
                        Are you willing to stay in regional areas for a short stint (1-4 weeks) where accommodation,
                        meal allowance and travel costs are covered?
                    </div>
                </div>
                <div class="form_text" v-if="currentStep == 2">
                    <div class="text">
                        Would you consider anything longer than 4 weeks?
                    </div>
                </div>
                <div class="button_submit mb0 buttons-group">
                    <el-button  type="blue_light" @click="setStepValue(0)">
                        No
                    </el-button>
                    <el-button  type="blue" @click="setStepValue(1)">
                        Yes
                    </el-button>
                </div>
            </el-form>
            <div class="background-circles">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
            </div>
        </div>
    </div>
</template>


<script>
    import {
        onMounted,
        inject,
        ref
    } from 'vue';

    import {
        addIcons
    } from 'ionicons'
    import {
        arrowBackOutline
    } from 'ionicons/icons'
    addIcons({
        'arrow-back-outline': arrowBackOutline
    })
    import {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
    } from '@ionic/vue';

    import {
        useStore
    } from 'vuex'

    import {
        useRouter,
        useRoute
    } from 'vue-router'
    import SvgIcon from '@/components/Svg/SvgIcon.vue';

    export default {
        components: {
            IonToolbar,
            IonButton,
            IonButtons,
            IonIcon,
            SvgIcon
        },
        setup() {
            const $store = useStore()
            const $router = useRouter()
            const $route = useRoute()
            const setPageClassGlobal = inject(['setPageClassGlobal']);

            const routeName = $route.name;

            const userData = $store.getters.GET_USER_DATA;
            const travel = userData.travel
            console.log(travel);
            const stepsNames = Object.keys(travel)
            console.log(stepsNames);

            let currentStep = ref(0);

            Object.keys(userData.travel).forEach(x => travel[x] = 0)

            console.log(currentStep.value);
            console.log(travel);

            const setStepValue = (value) => {
                const stepName = stepsNames[currentStep.value];
                travel[stepName] = value
                if (currentStep.value == stepsNames.length - 1 || (currentStep.value == 0 && value == 0)) {
                    save(travel)
                } else {
                    currentStep.value += 1
                }
            }


            const goBack = async() => {
                if (currentStep.value == 0) {
                    const back = await $store.dispatch("getAuthPageBack");
                    $router.push({
                        name: back,
                    });
                } else {
                    currentStep.value -= 1
                }
            };

            const goNext = () => {
                    $router.push({
                        name: 'onboard_languages',
                    })
            };

            const skip = () => {
                $store.dispatch('addAuthPageBack', $route.name);
                goNext()
            }

            const save = async (data) => {
                try {
                    await $store.dispatch('SAVE_USER_DATA', {
                        travel: data
                    });
                    goNext()
                } catch (error) {
                    console.log('error submit!!');
                }
            }


            onMounted(() => {
                setPageClassGlobal('global_onboard_internal_page');
            });

            return {
                goBack,
                skip,
                currentStep,
                setStepValue,
                routeName
            }
        },
    }
</script>